import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { VscMenu } from 'react-icons/vsc';

import SidebarMenuItem from './SidebarMenuItem';
import { WIDGET_ACTIONS } from '../../constants';

import { openModal } from 'features/modalSlice';
import { applyImportantStyles } from '../../lib';

import './SidebarMenu.css';

const SidebarMenu = ({ menuItems, onClick }) => {
    // const poweredBy =
    //    useSelector((state) => state.miniBookingWidget?.data?.poweredBy) || {};

    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);

    const handleMouseEnter = () => {
        if (!isOpen) {
            setIsOpen(true);
        }
    };

    const handleMouseLeave = () => {
        if (isOpen) {
            setIsOpen(false);
        }
    };

    const data = useSelector((state) => state.miniBookingWidget?.data) || {};

    return (
        <div
            className={`ab-sidebar-menu ${
                isOpen ? 'ab-sidebar-menu--open' : ''
            }`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <button className="ab-sidebar-menu-toggle-btn" onClick={onClick}>
                <VscMenu size={24} />
            </button>

            <nav className="ab-sidebar-menu-cnt">
                <ul>
                    {menuItems.map((menuItem, index) => {
                        const menuAction = menuItem?.menuAction;
                        let onClick;
                        switch (menuAction) {
                            case WIDGET_ACTIONS.SHOW_CONTACT_US_FORM:
                                onClick = () => {
                                    dispatch(
                                        openModal({
                                            modalId: 'ContactUsModal',
                                        })
                                    );
                                };

                                break;
                            case WIDGET_ACTIONS.SHOW_CLICK_2_CALL_FORM:
                                onClick = () => {
                                    dispatch(
                                        openModal({
                                            modalId: 'Click2CallModal',
                                        })
                                    );
                                };
                                break;
                            case WIDGET_ACTIONS.SHOW_SHARE_HOTEL_FORM:
                                onClick = () => {
                                    dispatch(
                                        openModal({
                                            modalId: 'ShareHotelModal',
                                        })
                                    );
                                };
                                break;
                            default:
                                onClick = undefined;
                        }
                        return (
                            <SidebarMenuItem
                                menuName={menuItem?.menuname}
                                menuLink={menuItem?.menulink}
                                menuIcon={menuItem?.menuicon}
                                key={index}
                                onClick={onClick}
                            />
                        );
                    })}
                </ul>
            </nav>
            {!data.disableAllLogos && (
                <div
                    className="ab-PoweredByClass"
                    ref={(el) => {
                        applyImportantStyles(el, {
                            'font-size': '12px',
                        });
                    }}
                >
                    <a
                        href={data.LogoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{}}
                    >
                        <img
                            src={data.CustomLogo}
                            alt=""
                            ref={(el) => {
                                applyImportantStyles(el, {
                                    display: 'unset',
                                    float: 'unset',
                                });
                            }}
                        />
                    </a>
                </div>
            )}
        </div>
    );
};

SidebarMenu.propTypes = {
    menuItems: PropTypes.array,
    onClick: PropTypes.func,
};

export default SidebarMenu;
